import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha, useTheme } from '@mui/material/styles';
import PrimaryButton from 'components/buttons/PrimaryButton';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { NavItem } from './components';
import LoginIcon from '@mui/icons-material/Login';

const Topbar = ({ onSidebarOpen, pages, colorInvert = false }) => {
    const theme = useTheme();
    const {
        about: aboutPages,
        program: programPages,
        submission: abstractPages,
        gallery: galleryPages,
    } = pages;

    return (
        <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            width={1}
        >
            <Link to={'/'}>
                <Box
                    display={'flex'}
                    gap={2}
                    title="Ina ACC"
                    width={{ xs: 150, md: 150 }}
                >
                    <Box
                        component={'img'}
                        src={`${process.env.PUBLIC_URL}/logo-semarang.webp`}
                        height={1}
                        width={1}
                    />
                </Box>
            </Link>

            <Box
                sx={{ display: { xs: 'none', md: 'flex', gap: 30 } }}
                alignItems={'center'}
            >
                <NavItem
                    title={'Abstract Submission'}
                    id={'abstract-pages'}
                    items={abstractPages}
                    colorInvert={colorInvert}
                />

                <Box>
                    <NavItem
                        title={'Program'}
                        id={'program-pages'}
                        items={programPages}
                        colorInvert={colorInvert}
                    />
                </Box>

                <Box>
                    <NavItem
                        title={'About'}
                        id={'about-pages'}
                        items={aboutPages}
                        colorInvert={colorInvert}
                    />
                </Box>
                <Box>
                    <NavItem
                        title={'Gallery'}
                        id={'gallery-pages'}
                        items={galleryPages}
                        colorInvert={colorInvert}
                    />
                </Box>
                <Box marginLeft={4}></Box>
                <Box marginLeft={2}>
                    <Link to={'/signin'} style={{ textDecoration: 'none' }}>
                        <PrimaryButton
                            variant="contained"
                            color="primary"
                            size="large"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                            }}
                        >
                            Sign In <LoginIcon />
                        </PrimaryButton>
                    </Link>
                </Box>
            </Box>
            <Box
                sx={{ display: { xs: 'block', md: 'none' } }}
                alignItems={'center'}
            >
                <Button
                    onClick={() => onSidebarOpen()}
                    aria-label="Menu"
                    variant={'outlined'}
                    sx={{
                        borderRadius: 2,
                        minWidth: 'auto',
                        padding: 1,
                        borderColor: alpha(theme.palette.divider, 0.2),
                    }}
                >
                    <MenuIcon />
                </Button>
            </Box>
        </Box>
    );
};

Topbar.propTypes = {
    onSidebarOpen: PropTypes.func,
    pages: PropTypes.object,
    colorInvert: PropTypes.bool,
};

export default Topbar;
